import React from 'react'

const AccountingPayment = () => {
  return (
    <div>AccountingPayment</div>
  )
}

export default AccountingPayment